import {GET_USER_HISTORY, GET_USER_HISTORY_FAIL, SET_FAIL_MESSAGE_HISTORY_USER} from "../actionTypes";

const initialState = {
    userHistory:[],
    message:""
}

const userHistoryReducer = (state = initialState, action) => {
    switch (action.type){
        case GET_USER_HISTORY:
            return{
                ...state,
                userHistory: action.payload.projectHistory,
                message: action.payload.message
            }
        case GET_USER_HISTORY_FAIL:
            return{
                ...state
            }
        case SET_FAIL_MESSAGE_HISTORY_USER:
            return {
                message: action.payload.message
            }
        default:
            return{
                ...state
            }
    }
}
export default userHistoryReducer